export default __webpack_public_path__ + "static/media/trial-end.24b97a1e.png";